import { Route, useParams } from "react-router-dom";
import NoticesPage from "@/v2/pages/notice/NoticesPage";
import NoticePage from "@/v2/pages/notice/NoticePage";
import { noticeUris } from "./noticeUris";

export const noticeRoutes = (
  <>
    <Route path={noticeUris.root} element={<NoticesPage />}>
      <Route path={noticeUris.notice} element={<NoticePage />} />
    </Route>
  </>
);
